// extracted by mini-css-extract-plugin
export default {"genericButton":"GenericButton_genericButton__lQ1yA","icon":"GenericButton_icon__wDllE","baseline":"GenericButton_baseline__cRorR","buttonText":"GenericButton_buttonText__rooSZ"};